document.querySelectorAll(".article-handle").forEach(h => {
    const handleText = h.innerText || "";
    const parsed = handleText.match(/[^\s\/]*?(?=\/)/g) || "";
    const words = (parsed[0] || "").split("-").filter(a => a);
    if (words.length > 0) {
        h.innerText = words.join(" ");
    }
});